/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TaskAssigneeType } from '../models/TaskAssigneeType';
import type { TaskCreateBodyParams } from '../models/TaskCreateBodyParams';
import type { TaskCreateResponse } from '../models/TaskCreateResponse';
import type { TaskDeleteResponse } from '../models/TaskDeleteResponse';
import type { TaskGetResponse } from '../models/TaskGetResponse';
import type { TaskListResponse } from '../models/TaskListResponse';
import type { TaskStatus } from '../models/TaskStatus';
import type { TaskUpdateBodyParams } from '../models/TaskUpdateBodyParams';
import type { TaskUpdateResponse } from '../models/TaskUpdateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TasksService {
    /**
     * @param limit
     * @param pageToken
     * @param dueBefore Filter tasks due before this date.
     * @param dueAfter Filter tasks due after this date.
     * @param conversationId Filter by conversation.
     * @param assignedToType Filter by assignee entity type.
     * @param assignedToId Filter by assignee identifier.
     * @param status Filter by lifecycle status.
     * @returns TaskListResponse Ok
     * @throws ApiError
     */
    public static getTasks(
        limit?: number,
        pageToken?: string,
        dueBefore?: string,
        dueAfter?: string,
        conversationId?: number,
        assignedToType?: TaskAssigneeType,
        assignedToId?: string,
        status?: TaskStatus,
    ): CancelablePromise<TaskListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks',
            query: {
                'limit': limit,
                'pageToken': pageToken,
                'dueBefore': dueBefore,
                'dueAfter': dueAfter,
                'conversationId': conversationId,
                'assignedToType': assignedToType,
                'assignedToId': assignedToId,
                'status': status,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns TaskCreateResponse Ok
     * @throws ApiError
     */
    public static createTask(
        requestBody: TaskCreateBodyParams,
    ): CancelablePromise<TaskCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tasks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param taskId
     * @returns TaskGetResponse Ok
     * @throws ApiError
     */
    public static getTask(
        taskId: string,
    ): CancelablePromise<TaskGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tasks/{taskId}',
            path: {
                'taskId': taskId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param taskId
     * @param requestBody
     * @returns TaskUpdateResponse Ok
     * @throws ApiError
     */
    public static updateTask(
        taskId: string,
        requestBody: TaskUpdateBodyParams,
    ): CancelablePromise<TaskUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tasks/{taskId}',
            path: {
                'taskId': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param taskId
     * @returns TaskDeleteResponse Ok
     * @throws ApiError
     */
    public static deleteTask(
        taskId: string,
    ): CancelablePromise<TaskDeleteResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tasks/{taskId}',
            path: {
                'taskId': taskId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
}
